import type { FC, ReactNode } from "react";

export interface SlotPlaceholderProps {
  name: string;
  fallback?: ReactNode;
}

/**
 * Marker component emitted by parseTemplate() for each `<slot name="…">` element it finds
 * inside a host-page `<template>`. The placeholder itself is never rendered as a React
 * component — `Templated.tsx#renderTemplate` matches it by reference (`tree.type ===
 * SlotPlaceholder`) and substitutes either harvested widget content or a wired-up version
 * of the embedder's fallback. This export is the marker reference.
 */
export const SlotPlaceholder: FC<SlotPlaceholderProps> = ({ fallback }) => (
  <>{fallback ?? null}</>
);
